// third-party
import { UserOctagon, Bucket, Code1, MessageEdit, Setting2, DocumentText } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS — ADMIN ||============================== //

const adminMenu: NavItemType = {
  id: 'admin',
  title: 'admin.role',
  type: 'group',
  children: [
    {
      id: 'impersonate',
      title: 'admin.impersonate',
      type: 'item',
      url: '/admin/impersonate',
      icon: UserOctagon
    },
    {
      id: 'minio-files',
      title: 'admin.minioFiles',
      type: 'item',
      url: '/admin/minio',
      icon: Bucket
    },
    {
      id: 'flow-engine',
      title: 'admin.flowEngine',
      type: 'item',
      url: '/admin/flow-engine',
      icon: Code1
    },
    {
      id: 'prompt-builder',
      title: 'admin.promptBuilder',
      type: 'item',
      url: '/admin/prompt-builder',
      icon: MessageEdit
    },
    {
      id: 'system-settings',
      title: 'admin.systemSettings',
      type: 'item',
      url: '/admin/settings',
      icon: Setting2
    },
    {
      id: 'prompt-audit',
      title: 'admin.promptAudit',
      type: 'item',
      url: '/admin/prompt-audit',
      icon: DocumentText
    }
  ]
};

export default adminMenu;
